import { useTranslation } from "react-i18next";
import { FlowExecutionStepReadDetailStatusEnum } from "@hilos/types/private-schema";
import LoaderSpinner from "src/components/LoaderSpinner";

interface FlowExecutionStepStatusBadgeProps {
  status: FlowExecutionStepReadDetailStatusEnum;
}

export default function FlowExecutionStepStatusBadge({
  status,
}: FlowExecutionStepStatusBadgeProps) {
  const { t } = useTranslation();
  switch (status) {
    case "WAITING_TO_START":
      return (
        <div className="inline-flex gap-2 uppercase items-center rounded-full bg-gray-100 px-3 py-0.5 text-xs font-medium text-gray-800">
          {t(
            "flow-executions:flow-execution-step.status.waiting-to-start",
            "Waiting to start"
          )}{" "}
          <span className="-mr-3">
            <LoaderSpinner />
          </span>
        </div>
      );
    case "RUNNING":
      return (
        <span className="inline-flex uppercase items-center rounded-full bg-indigo-100 px-3 py-0.5 text-xs font-medium text-indigo-800">
          {t("flow-executions:flow-execution-step.status.running", "Running")}
        </span>
      );
    case "COMPLETED":
      return (
        <span className="inline-flex uppercase items-center rounded-full bg-green-100 px-3 py-0.5 text-xs font-medium text-green-800">
          {t(
            "flow-executions:flow-execution-step.status.completed",
            "Completed"
          )}
        </span>
      );
    case "CANCELED":
      return (
        <span className="inline-flex uppercase items-center rounded-full bg-red-100 px-3 py-0.5 text-xs font-medium text-red-800">
          {t("flow-executions:flow-execution-step.status.canceled", "Canceled")}
        </span>
      );
    case "FAILED":
      return (
        <span className="inline-flex uppercase items-center rounded-full bg-red-100 px-3 py-0.5 text-xs font-medium text-red-800">
          {t("flow-executions:flow-execution-step.status.failed", "Failed")}
        </span>
      );
    case "EXPIRED":
      return (
        <span className="inline-flex uppercase items-center rounded-full bg-red-100 px-3 py-0.5 text-xs font-medium text-red-800">
          {t("flow-executions:flow-execution-step.status.expired", "Expired")}
        </span>
      );
    default:
      return (
        <span className="inline-flex uppercase items-center rounded-full bg-gray-100 px-3 py-0.5 text-xs font-medium text-gray-800">
          {status}
        </span>
      );
  }
}
